"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Avatar = _interopRequireDefault(require("./new-components/Avatar/Avatar"));
var _constants = require("./new-components/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ProfileBadge = /*#__PURE__*/function (_Component) {
  function ProfileBadge() {
    (0, _classCallCheck2["default"])(this, ProfileBadge);
    return _callSuper(this, ProfileBadge, arguments);
  }
  (0, _inherits2["default"])(ProfileBadge, _Component);
  return (0, _createClass2["default"])(ProfileBadge, [{
    key: "returnInitial",
    value: function returnInitial(string) {
      return string.charAt(0);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
        profile = _this$props.profile,
        memberIsBooker = _this$props.memberIsBooker;
      var memberWithInitials = profile && profile.firstName && profile.lastName;
      if (profile && profile.fbUid) {
        return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
          image: {
            url: "https://graph.facebook.com/v2.10/".concat(profile.fbUid, "/picture?type=square&width=100"),
            alt: "".concat(profile.firstName, " ").concat(profile.lastName)
          }
        });
      }
      if (memberWithInitials) {
        var initials = profile.firstName.charAt(0) + profile.lastName.charAt(0);
        return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
          avatarColor: memberIsBooker ? _constants.AVATAR_COLORS.SECONDARY : _constants.AVATAR_COLORS.PRIMARY,
          initials: initials.toUpperCase()
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
        avatarSize: _constants.AVATAR_SIZES.MEDIUM,
        avatarType: _constants.AVATAR_TYPES.CIRCLE,
        avatarColor: _constants.AVATAR_COLORS.CONTRAST_LOW,
        image: {
          url: 'https://cdn.theyachtweek.com/assets/icons/user-icon.png',
          alt: 'place holder icon'
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.renderContent());
    }
  }]);
}(_react.Component);
ProfileBadge.propTypes = {
  profile: _propTypes["default"].object,
  memberIsBooker: _propTypes["default"].bool
};
var _default = exports["default"] = ProfileBadge;